var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs } from "react-bootstrap";
var GenericTabs = function (props) {
    var _a = __read(useState(props.defaultActiveKey), 2), key = _a[0], setKey = _a[1];
    var _b = __read(useState(props.tabsArray), 2), tabList = _b[0], setTabList = _b[1];
    var _c = __read(useState(true), 2), isLeftScrollDisabled = _c[0], setIsLeftScrollDisabled = _c[1];
    var _d = __read(useState(false), 2), isRightScrollDisabled = _d[0], setIsRightScrollDisabled = _d[1];
    var tabsRef = useRef(null);
    var hasScrollBar = function () {
        var _a, _b;
        return ((_a = tabsRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) < ((_b = tabsRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth);
    };
    var scrollTabsBar = function (scrollBy) {
        var _a, _b, _c, _d, _e;
        tabsRef.current.scrollLeft = ((_a = tabsRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) + scrollBy;
        setIsLeftScrollDisabled(((_b = tabsRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) <= 0);
        setIsRightScrollDisabled(((_c = tabsRef.current) === null || _c === void 0 ? void 0 : _c.scrollLeft) >=
            ((_d = tabsRef.current) === null || _d === void 0 ? void 0 : _d.scrollWidth) - (((_e = tabsRef.current) === null || _e === void 0 ? void 0 : _e.offsetWidth) + 5));
    };
    var onSelectAction = function (selected, e) {
        setKey(selected);
        if (props.callBackFunction)
            props === null || props === void 0 ? void 0 : props.callBackFunction(selected, e);
    };
    useEffect(function () {
        if (props.tabsArray && props.tabsArray.length > 0) {
            setTabList(props.tabsArray);
        }
    }, [props.tabsArray]);
    useEffect(function () {
        if (props.defaultActiveKey) {
            setKey(props.defaultActiveKey);
        }
    }, [props.defaultActiveKey]);
    return (React.createElement("div", { className: "d-flex w-100 tab-parent-class" },
        React.createElement("div", { ref: tabsRef, className: "generic-tabs w-100 ".concat(props.externalClassName ? props.externalClassName : "") },
            React.createElement(Tabs, { defaultActiveKey: props.defaultActiveKey, onSelect: onSelectAction, activeKey: key, className: props.navClass }, tabList &&
                tabList.map(function (tab, idx) {
                    return (React.createElement(Tab, { title: React.createElement(React.Fragment, null, tab === null || tab === void 0 ? void 0 :
                            tab.title,
                            (tab === null || tab === void 0 ? void 0 : tab.suffix) ? props.suffixComp : ""), eventKey: tab === null || tab === void 0 ? void 0 : tab.eventKey, disabled: tab === null || tab === void 0 ? void 0 : tab.disabled, key: idx }, key === (tab === null || tab === void 0 ? void 0 : tab.eventKey) && (tab === null || tab === void 0 ? void 0 : tab.tabContent)));
                }))),
        props.horizontalScroll && (React.createElement("div", { className: "displayFlex generic-tabs-scroller" },
            React.createElement("div", { className: "arrow-shadow" }),
            React.createElement("div", { className: "d-flex scroller-icons ".concat(hasScrollBar() ? "" : "d-none") },
                React.createElement("i", { className: "edel-icon-arrow-left1 ".concat(isLeftScrollDisabled ? "disabled" : ""), onClick: function () { return scrollTabsBar(-100); } }),
                React.createElement("i", { className: "edel-icon-arrow-right1 ".concat(isRightScrollDisabled ? "disabled" : ""), onClick: function () { return scrollTabsBar(100); } }))))));
};
export default GenericTabs;
